(function () {
  const root = document.querySelector('[data-sipit-cart]');
  if (!root || root.dataset.sipitCartInit === '1') return;
  root.dataset.sipitCartInit = '1';

  async function changeLine(line, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not update cart.');
    }
    window.location.reload();
  }

  root.querySelectorAll('[data-sipit-cart-line]').forEach((lineEl) => {
    const line = Number(lineEl.dataset.line);
    const qtyVal = lineEl.querySelector('[data-sipit-qty-value]');
    const minus = lineEl.querySelector('[data-sipit-qty-minus]');
    const plus = lineEl.querySelector('[data-sipit-qty-plus]');
    const remove = lineEl.querySelector('[data-sipit-cart-remove]');

    const getQty = () => Number(qtyVal?.textContent || '1');

    if (minus) {
      minus.addEventListener('click', async () => {
        const next = Math.max(0, getQty() - 1);
        minus.disabled = true;
        try {
          await changeLine(line, next);
        } catch (error) {
          alert(error.message);
          minus.disabled = false;
        }
      });
    }

    if (plus) {
      plus.addEventListener('click', async () => {
        plus.disabled = true;
        try {
          await changeLine(line, getQty() + 1);
        } catch (error) {
          alert(error.message);
          plus.disabled = false;
        }
      });
    }

    if (remove) {
      remove.addEventListener('click', async () => {
        remove.disabled = true;
        try {
          await changeLine(line, 0);
        } catch (error) {
          alert(error.message);
          remove.disabled = false;
        }
      });
    }
  });
})();
